export default __webpack_public_path__ + "static/media/tokenBadgePlatinum108@2x.e7edecf8.png";